export enum ButtonStyle {
  Primary = 'primary',
  Secondary = 'secondary',
  Contrast = 'contrast',
  Transparent = 'transparent',
  Danger = 'danger',
  Light = 'light',

  // From Backend
  BackendPrimary = 'backend-primary',
  BackendSecondary = 'backend-secondary'
}

export enum ButtonSize {
  Small = 'small',
  Medium = 'medium',
  Big = 'big',
  Large = 'large',
  Icon = 'icon'
}

export type ButtonType = 'submit' | 'reset' | 'button';
